<template>

  <ContentsPageTitleV2 capital="SEE HOW OUR PRODUCTS ARE USED IM YOUR APPLICATIONS" title="Use Case"
                       description="Exterior"/>
  <CardUserCase :contents="ADAS"/>


</template>

<script setup>
import CardUserCase from '~/components/contents/CardUserCase.vue'

useHead({
  title: 'Exterior - NAGASE THAILAND Engineering Plastics',
})
const ADAS = [
  {
    "pdf": true,
    "img": "/pages/products/use-cases/cars.jpg",
    "title": "Digital Matrix LED Headlight Solution",
    "to": "/pages/products/use-cases/cars.pdf"
  },
  {
    "pdf": true,
    "img": "/pages/products/use-cases/b03.jpg",
    "title": "LNP™ SLX COPOLYMER RESINS For Automotive Exteriors",
    "to": "/pages/products/use-cases/b03.pdf"
  },
  {
    "pdf": true,
    "img": "/pages/products/use-cases/das.jpg",
    "title": "NORYL GTX™ Resins Solutions for Automotive Tank Flaps",
    "to": "/pages/products/use-cases/das.pdf"
  },
  {
    "pdf": true,
    "img": "/pages/products/use-cases/djd.jpg",
    "title": "Primerless in- and on-line Painting conductive NORYL GTX™ Resins\n",
    "to": "/pages/products/use-cases/djd.pdf"
  }

]
</script>
